module.exports = __webpack_public_path__ + "img/eden.b940ec29.svg";